import { z } from 'zod'
import {
  ApiPaginatedResponseSchema,
} from './api'
import type {
  ApiPaginatedResponse,
} from './api'

// =====================================
// MAIN NOTIFICATION SCHEMA
// =====================================

export const NotificationSchema = z.object({
  id: z.string().uuid(),
  type: z.string(),
  data: z.record(z.unknown()),
  read_at: z.string().nullable(),
  created_at: z.string().nullable().optional(),
  updated_at: z.string().nullable().optional(),
})

export type Notification = z.infer<typeof NotificationSchema>

// =====================================
// API RESPONSE SCHEMAS
// =====================================

export const NotificationsPaginatedApiResponseSchema =
  ApiPaginatedResponseSchema(NotificationSchema)
export type NotificationsPaginatedApiResponse = ApiPaginatedResponse<Notification>

// =====================================
// UNREAD COUNT SCHEMA
// =====================================

export const UnreadCountSchema = z.object({
  unread_count: z.number(),
})

export type UnreadCount = z.infer<typeof UnreadCountSchema>
